module.exports = "./app-dist/templates/sidebar.3ce68a3e76415bbb0eec055b524880f7.html";